module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/Mosquito/Kanagawa_Mosquito_MRI_RCP26_End.png";